'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var applyDefaultOptions = require('./utils/apply-default-options');

var toMfsPath = require('./utils/to-mfs-path');

var log = require('debug')('ipfs:mfs:touch');

var errCode = require('err-code');

var UnixFS = require('ipfs-unixfs');

var toTrail = require('./utils/to-trail');

var addLink = require('./utils/add-link');

var updateTree = require('./utils/update-tree');

var updateMfsRoot = require('./utils/update-mfs-root');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode;

var mc = require('multicodec');

var mh = require('multihashes');

var defaultOptions = {
  mtime: undefined,
  flush: true,
  shardSplitThreshold: 1000,
  cidVersion: 0,
  hashAlg: 'sha2-256'
};

module.exports = function (context) {
  return /*#__PURE__*/function () {
    var _mfsTouch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, options) {
      var _yield$toMfsPath, cid, mfsDirectory, name, exists, node, updatedCid, cidVersion, metadata, _metadata, trail, parent, parentNode, result, newRootCid;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              options = applyDefaultOptions(options, defaultOptions);
              options.mtime = options.mtime || new Date();
              log("Touching ".concat(path, " mtime: ").concat(options.mtime));
              _context.next = 6;
              return toMfsPath(context, path);

            case 6:
              _yield$toMfsPath = _context.sent;
              cid = _yield$toMfsPath.cid;
              mfsDirectory = _yield$toMfsPath.mfsDirectory;
              name = _yield$toMfsPath.name;
              exists = _yield$toMfsPath.exists;
              cidVersion = options.cidVersion;

              if (exists) {
                _context.next = 20;
                break;
              }

              metadata = new UnixFS({
                type: 'file',
                mtime: options.mtime
              });
              node = new DAGNode(metadata.marshal());
              _context.next = 17;
              return context.ipld.put(node, mc.DAG_PB, {
                cidVersion: options.cidVersion,
                hashAlg: mh.names['sha2-256'],
                onlyHash: !options.flush
              });

            case 17:
              updatedCid = _context.sent;
              _context.next = 32;
              break;

            case 20:
              if (!(cid.codec !== 'dag-pb')) {
                _context.next = 22;
                break;
              }

              throw errCode(new Error("".concat(path, " was not a UnixFS node")), 'ERR_NOT_UNIXFS');

            case 22:
              cidVersion = cid.version;
              _context.next = 25;
              return context.ipld.get(cid);

            case 25:
              node = _context.sent;
              _metadata = UnixFS.unmarshal(node.Data);
              _metadata.mtime = options.mtime;
              node = new DAGNode(_metadata.marshal(), node.Links);
              _context.next = 31;
              return context.ipld.put(node, mc.DAG_PB, {
                cidVersion: cid.version,
                hashAlg: mh.names['sha2-256'],
                onlyHash: !options.flush
              });

            case 31:
              updatedCid = _context.sent;

            case 32:
              _context.next = 34;
              return toTrail(context, mfsDirectory, options);

            case 34:
              trail = _context.sent;
              parent = trail[trail.length - 1];
              _context.next = 38;
              return context.ipld.get(parent.cid);

            case 38:
              parentNode = _context.sent;
              _context.next = 41;
              return addLink(context, {
                parent: parentNode,
                name: name,
                cid: updatedCid,
                size: node.serialize().length,
                flush: options.flush,
                shardSplitThreshold: options.shardSplitThreshold,
                hashAlg: 'sha2-256',
                cidVersion: cidVersion
              });

            case 41:
              result = _context.sent;
              parent.cid = result.cid; // update the tree with the new child

              _context.next = 45;
              return updateTree(context, trail, options);

            case 45:
              newRootCid = _context.sent;
              _context.next = 48;
              return updateMfsRoot(context, newRootCid);

            case 48:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function mfsTouch(_x, _x2) {
      return _mfsTouch.apply(this, arguments);
    }

    return mfsTouch;
  }();
};